import React, { useEffect,useState, lazy } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import styled from 'styled-components'
import { ResetCSS } from "@pancakeswap-libs/uikit";
import BigNumber from "bignumber.js";
import useEagerConnect from "hooks/useEagerConnect";
import GlobalStyle from "./style/Global";
import Menu from "./components/Menu";
import SuspenseWithChunkError from "./components/SuspenseWithChunkError";
import ToastListener from "./components/ToastListener";
import PageLoader from "./components/PageLoader";



const Home = lazy(() => import("./views/Home"));
const NotFound = lazy(() => import("./views/NotFound"));

const AppWrapper = styled.div`
`

const BodyWrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;
`

// This config is required for number formating
BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
});

const App: React.FC = () => {
  useEffect(() => {
    console.warn = () => null;
  }, []);

  useEagerConnect();

  const [videoPlayed,setVideoPlayed] = useState(false)
  return (
    <AppWrapper style={{ overflow: 'hidden' }}>
    <HashRouter>
      <ResetCSS />

      <BodyWrapper>
        <SuspenseWithChunkError fallback={<PageLoader />}>
          <Switch>
            <Route path="/" exact>
              <Home videoPlayed={videoPlayed} setVideoPlayed={setVideoPlayed}/>
            </Route>
            <Route component={NotFound} />
          </Switch>
        </SuspenseWithChunkError>
        </BodyWrapper>
      <ToastListener />
    </HashRouter>
    </AppWrapper>
  );
};

export default React.memo(App);
